import { OrderResponse } from "models/orderResponse";
import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Col, Label, Row } from "reactstrap";
import { OrderService } from "services/OrderService";
import { toast } from "react-toastify";
toast.configure();
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { Puff } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
import { AuthData, useAuth } from "context/AuthProvider";
import { displayOrderAddress } from "helpers/orderAddress";
import {
  displayDeliveryNotes,
  displayItemDescription,
  displayOrDash,
  displayPackageNotes,
  isPlatformOrder,
} from "helpers/orderDetails";

const proofImageSrc = (value?: string | null): string => {
  const trimmed = String(value || "").trim();
  if (!trimmed) return "";
  if (trimmed.startsWith("data:image") || /^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  return `data:image/png;base64,${trimmed}`;
};

export interface OrderStatusModalProps {
  isOpen: boolean;
  handleIsOpen: () => void;
  getPDF: (value: string) => void;
  orderId: string;
}

const OrderStatusModal: React.FC<OrderStatusModalProps> = ({ isOpen, handleIsOpen, orderId, getPDF }: OrderStatusModalProps) => {
  const [order, setOrder] = useState<OrderResponse>();
  const [isLoading, setIsloading] = useState<boolean>(false);
  const navigate = useNavigate();
  const [user] = useAuth() as AuthData;

  useEffect(() => {
    if (!isOpen) {
      setIsloading(false);
      return;
    }
    if (!orderId || orderId === "undefined" || orderId === "null") {
      setOrder(undefined);
      setIsloading(false);
      toast.error("Order details are unavailable because the order ID is missing.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      handleIsOpen();
      navigate(`/${user?.role}/current-orders`, {
        replace: true,
        state: {
          message: "Order details could not be opened because the order ID was missing.",
        },
      });
      return;
    }

    setIsloading(true);
    OrderService.getOrderById(orderId)
      .then(res => {
        if (res.success) {
          console.log("order details",res.data)
          setOrder(res.data);

          setIsloading(false);
        } else {
          setOrder(undefined);
          setIsloading(false);
        }
      })
      .catch(err => {
        setIsloading(false);
        console.error(err);
      });
  }, [isOpen, orderId]);

  interface TextWithLineBreaksProps {
    text: string;
  }

  const TextWithLineBreaks: React.FC<TextWithLineBreaksProps> = ({ text }) => {
    const maxCharactersPerRow = 26;
    const lines: string[] = [];

    for (let i = 0; i < text.length; i += maxCharactersPerRow) {
      lines.push(text.slice(i, i + maxCharactersPerRow));
    }

    return (
      <div>
        {lines.map((line, index) => (
          <div key={index}>{line}</div>
        ))}
      </div>
    );
  };

  return (
    <React.Fragment>
      {isOpen && isLoading && <div className="d-flex justify-content-center align-items-center " style={{ height: "500px" }}>
        <Puff color="#FFD0B8" height={50} width={50} />
      </div>}
      <Modal className="modal-dialog modal-dialog-centered" isOpen={isOpen} toggle={handleIsOpen} size="xl">
        <ModalHeader className="text-center" toggle={handleIsOpen}>
          <div className="text-center">Order Details : {order?.uniqueId}</div>
        </ModalHeader>
        <ModalBody className="overflow-auto">
          <div className="d-flex justify-content-start px-lg-5">
            <div className="address-wrapper">
              <div className="row justify-content-center m-lg-5">
                <Row>
                  <Col lg="6">
                    <div className="mb-3 form-group">
                      <Label for="basicpill-companyuin-input9" className="place-order-title text-primary fw-bold">
                        Pick-Up Details
                      </Label>
                      <div>
                        <Row>
                          <Col lg="5" md="5" sm="4" xs="4">
                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                              Pickup address
                            </Label>
                          </Col>
                          <Col>
                            <Label> : </Label>
                          </Col>
                          <Col lg="5" md="6" sm="6" xs="6">
                            <Label for="basicpill-companyuin-input9" className="text-muted">
                              {displayOrDash(displayOrderAddress(order?.pickUpAddress))}
                              {order?.pickUpAddress?.postalCode?.trim() ? (
                                <>
                                  <br />
                                  {order.pickUpAddress.postalCode}
                                </>
                              ) : null}
                            </Label>
                          </Col>
                        </Row>
                      </div>
                      <div>
                        <Row>
                          <Col lg="5" md="5" sm="4" xs="4">
                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                              Company Name
                            </Label>
                          </Col>
                          <Col>
                            <Label> : </Label>
                          </Col>
                          <Col lg="5" md="6" sm="6" xs="6">
                            <Label for="basicpill-companyuin-input9" className="text-muted">
                              {displayOrDash(order?.pickUpAddress?.companyName)}
                            </Label>
                          </Col>
                        </Row>
                      </div>
                      <div>
                        <Row>
                          <Col lg="5" md="5" sm="4" xs="4">
                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                              Contact Name
                            </Label>
                          </Col>
                          <Col>
                            <Label> : </Label>
                          </Col>
                          <Col lg="5" md="6" sm="6" xs="6">
                            <Label for="basicpill-companyuin-input9" className="text-muted">
                              {displayOrDash(order?.pickUpAddress?.contactName)}
                            </Label>
                          </Col>
                        </Row>
                      </div>
                      <div>
                        <Row>
                          <Col lg="5" md="5" sm="4" xs="4">
                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                              Contact Phone
                            </Label>
                          </Col>
                          <Col>
                            <Label> : </Label>
                          </Col>
                          <Col lg="5" md="6" sm="6" xs="6">
                            <Label for="basicpill-companyuin-input9" className="text-muted">
                              {displayOrDash(order?.pickUpAddress?.contactPhone)}
                            </Label>
                          </Col>
                        </Row>
                      </div>
                      <div>
                        <Row>
                          <Col lg="5" md="5" sm="4" xs="4">
                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                              Pick - Up date and Time
                            </Label>
                          </Col>
                          <Col>
                            <Label> : </Label>
                          </Col>
                          <Col lg="5" md="6" sm="6" xs="6">
                            <Label for="basicpill-companyuin-input9" className="text-muted">
                              {order?.packageReadyTime
                                ? moment(order.packageReadyTime).format("YYYY-MM-DD HH:mm")
                                : "-"}
                            </Label>
                          </Col>
                        </Row>
                      </div>
                      <div>
                        <Row>
                          <Col lg="5" md="5" sm="4" xs="4">
                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                              Unit No
                            </Label>
                          </Col>
                          <Col>
                            <Label> : </Label>
                          </Col>
                          <Col lg="5" md="6" sm="6" xs="6">
                            <Label for="basicpill-companyuin-input9" className="text-muted">
                              {displayOrDash(order?.pickUpAddress?.unit)}
                            </Label>
                          </Col>
                        </Row>
                      </div>
                      {!isPlatformOrder(order) ? (
                      <div>
                        <Row>
                          <Col lg="5" md="5" sm="4" xs="4">
                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                              Notes About Package
                            </Label>
                          </Col>
                          <Col>
                            <Label> : </Label>
                          </Col>
                          <Col lg="5" md="6" sm="6" xs="6">
                            <Label for="basicpill-companyuin-input9" className="text-muted">
                              <TextWithLineBreaks text={displayPackageNotes(order)} />
                            </Label>
                          </Col>
                        </Row>
                      </div>
                      ) : null}
                         <div>
                        <Row>
                          <Col lg="5" md="5" sm="4" xs="4">
                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                          Item Description / Size
                            </Label>
                          </Col>
                          <Col>
                            <Label> : </Label>
                          </Col>
                          <Col lg="5" md="6" sm="6" xs="6">
                            <Label for="basicpill-companyuin-input9" className="text-muted">
                              <TextWithLineBreaks text={displayItemDescription(order)} />
                            </Label>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                  <Col lg="6">
                    <div className="mb-3 form-group">
                      <Label for="basicpill-companyuin-input9" className="place-order-title text-primary fw-bold">
                        Delivery Details
                      </Label>
                      <Row>
                        <div>
                          <Row>
                            <Col lg="5" md="5" sm="4" xs="4">
                              <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                Delivery address
                              </Label>
                            </Col>
                            <Col>
                              <Label> : </Label>
                            </Col>
                            <Col lg="5" md="6" sm="6" xs="6">
                              <Label for="basicpill-companyuin-input9" className="text-muted">
                                {displayOrDash(displayOrderAddress(order?.deliveryAddress))}
                                {order?.deliveryAddress?.postalCode?.trim() ? (
                                  <>
                                    <br />
                                    {order.deliveryAddress.postalCode}
                                  </>
                                ) : null}
                              </Label>
                            </Col>
                          </Row>
                        </div>
                        <div>
                          <Row>
                            <Col lg="5" md="5" sm="4" xs="4">
                              <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                Company Name
                              </Label>
                            </Col>
                            <Col>
                              <Label> : </Label>
                            </Col>
                            <Col lg="5" md="6" sm="6" xs="6">
                              <Label for="basicpill-companyuin-input9" className="text-muted">
                                {displayOrDash(order?.deliveryAddress?.companyName)}
                              </Label>
                            </Col>
                          </Row>
                        </div>
                        <div>
                          <Row>
                            <Col lg="5" md="5" sm="4" xs="4">
                              <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                Contact Name
                              </Label>
                            </Col>
                            <Col>
                              <Label> : </Label>
                            </Col>
                            <Col lg="5" md="6" sm="6" xs="6">
                              <Label for="basicpill-companyuin-input9" className="text-muted">
                                {displayOrDash(order?.deliveryAddress?.contactName)}
                              </Label>
                            </Col>
                          </Row>
                        </div>
                        <div>
                          <Row>
                            <Col lg="5" md="5" sm="4" xs="4">
                              <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                Contact Phone
                              </Label>
                            </Col>
                            <Col>
                              <Label> : </Label>
                            </Col>
                            <Col lg="5" md="6" sm="6" xs="6">
                              <Label for="basicpill-companyuin-input9" className="text-muted">
                                {displayOrDash(order?.deliveryAddress?.contactPhone)}
                              </Label>
                            </Col>
                          </Row>
                        </div>
                        <div>
                          <Row>
                            <Col lg="5" md="5" sm="4" xs="4">
                              <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                Total Number of Items
                              </Label>
                            </Col>
                            <Col>
                              <Label> : </Label>
                            </Col>
                            <Col lg="5" md="6" sm="6" xs="6">
                              <Label for="basicpill-companyuin-input9" className="text-muted">
                                {displayOrDash(order?.totalItems)}
                              </Label>
                            </Col>
                          </Row>
                        </div>
                        <div>
                          <Row>
                            <Col lg="5" md="5" sm="4" xs="4">
                              <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                Total Weight of all Items
                              </Label>
                            </Col>
                            <Col>
                              <Label> : </Label>
                            </Col>
                            <Col lg="5" md="6" sm="6" xs="6">
                              <Label for="basicpill-companyuin-input9" className="text-muted">
                                {displayOrDash(order?.totalWeight)}
                              </Label>
                            </Col>
                          </Row>
                        </div>
                        <div>
                          <Row>
                            <Col lg="5" md="5" sm="4" xs="4">
                              <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                Unit No
                              </Label>
                            </Col>
                            <Col>
                              <Label> : </Label>
                            </Col>
                            <Col lg="5" md="6" sm="6" xs="6">
                              <Label for="basicpill-companyuin-input9" className="text-muted">
                                {displayOrDash(order?.deliveryAddress?.unit)}
                              </Label>
                            </Col>
                          </Row>
                        </div>
                        <div>
                          <Row>
                            <Col lg="5" md="5" sm="4" xs="4">
                              <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                Choose Vehicle
                              </Label>
                            </Col>
                            <Col>
                              <Label> : </Label>
                            </Col>
                            <Col lg="5" md="6" sm="6" xs="6">
                              <Label for="basicpill-companyuin-input9" className="text-muted">
                                {displayOrDash(order?.vehicleType)}
                              </Label>
                            </Col>
                          </Row>
                        </div>
                        <div>
                          <Row>
                            <Col lg="5" md="5" sm="4" xs="4">
                              <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                Delivery Option
                              </Label>
                            </Col>
                            <Col>
                              <Label> : </Label>
                            </Col>
                            <Col lg="5" md="6" sm="6" xs="6">
                              <Label for="basicpill-companyuin-input9" className="text-muted">
                                {order?.deliveryOption === "delivery_verification_pin" && order?.deliveryPin
                                  ? order.deliveryPin
                                  : order?.deliveryOption
                                    ? order.deliveryOption.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase())
                                    : "-"}
                              </Label>
                            </Col>
                          </Row>
                        </div>
                        <div>
                          <Row>
                            <Col lg="5" md="5" sm="4" xs="4">
                              <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                Delivery Notes
                              </Label>
                            </Col>
                            <Col>
                              <Label> : </Label>
                            </Col>
                            <Col lg="5" md="6" sm="6" xs="6">
                              <Label for="basicpill-companyuin-input9" className="text-muted">
                                <TextWithLineBreaks text={displayDeliveryNotes(order) || "-"} />
                              </Label>
                            </Col>
                          </Row>
                        </div>
                      </Row>
                    </div>
                  </Col>
                  <Col lg="6">
                    <div className="mb-3 form-group">
                      <Label for="basicpill-companyuin-input9" className="place-order-title text-primary fw-bold">
                        Quote Details
                      </Label>
                      <Row>
                        <div>
                          <Row>
                            <Col lg="5" md="5" sm="4" xs="4">
                              <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                Total distance
                              </Label>
                            </Col>
                            <Col>
                              <Label> : </Label>
                            </Col>
                            <Col lg="5" md="6" sm="6" xs="6">
                              <Label for="basicpill-companyuin-input9" className="text-muted">
                                {displayOrDash(order?.totalDistance)}
                              </Label>
                            </Col>
                          </Row>
                        </div>
                        <div>
                          <Row>
                            <Col lg="5" md="5" sm="4" xs="4">
                              <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                Subtotal
                              </Label>
                            </Col>
                            <Col>
                              <Label> : </Label>
                            </Col>
                            <Col lg="5" md="6" sm="6" xs="6">
                              <Label for="basicpill-companyuin-input9" className="text-muted">
                                {order?.subTotal == null ? "-" : `$${order.subTotal}`}
                              </Label>
                            </Col>
                          </Row>
                        </div>
                        {order?.appliedPromo && (
                          <div>
                            <Row>
                              <Col lg="5" md="5" sm="4" xs="4">
                                <Label
                                  for="basicpill-companyuin-input9"
                                  className="text-muted fw-semibold"
                                >
                                  Promo  Discount applied
                                </Label>
                              </Col>
                              <Col>
                                <Label> : </Label>
                              </Col>
                              <Col lg="5" md="6" sm="6" xs="6">
                                <Label
                                  for="basicpill-companyuin-input9"
                                  className="text-muted"
                                >
                                  {order?.appliedPromo?.discountPercent?.toString()+ "% "}
                                </Label>
                              </Col>
                            </Row>
                          </div>
                        )}

                        <div>
                          <Row>
                            <Col lg="5" md="5" sm="4" xs="4">
                              <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                HST 13%
                              </Label>
                            </Col>
                            <Col>
                              <Label> : </Label>
                            </Col>
                            <Col lg="5" md="6" sm="6" xs="6">
                              <Label for="basicpill-companyuin-input9" className="text-muted">
                                {order?.hst == null ? "-" : `$${order.hst}`}
                              </Label>
                            </Col>
                          </Row>
                        </div>
                        <div>
                          <Row>
                            <Col lg="5" md="5" sm="4" xs="4">
                              <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                Total Fare
                              </Label>
                            </Col>
                            <Col>
                              <Label> : </Label>
                            </Col>
                            <Col lg="5" md="6" sm="6" xs="6">
                              <Label for="basicpill-companyuin-input9" className="text-muted">
                                {order?.totalFare == null ? "-" : `$${order.totalFare.toFixed(2)}`}
                              </Label>
                            </Col>
                          </Row>
                        </div>
                      </Row>
                    </div>
                  </Col>
                  <Col lg="6">
                    <div className="mb-3 form-group">
                      <Label className="fs-6 text-primary fw-bold">Order Status</Label>
                      <div>
                        <Row>
                          <Col lg="5" md="5" sm="4" xs="4">
                            <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                              Status
                            </Label>
                          </Col>
                          <Col>
                            <Label> : </Label>
                          </Col>
                          <Col lg="5" md="6" sm="6" xs="6">
                            <Label for="basicpill-companyuin-input9" className="text-muted">
                              {order?.orderStatus
                                ? order?.orderStatus.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase())
                                : "Pending"}
                            </Label>
                          </Col>
                        </Row>
                      </div>
                      {(order?.orderStatus === "assigned") && (
                        <div>
                          <Row>
                            <Col lg="5" md="5" sm="4" xs="4">
                              <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                Driver
                              </Label>
                            </Col>
                            <Col>
                              <Label> : </Label>
                            </Col>
                            <Col lg="5" md="6" sm="6" xs="6">
                              <Label for="basicpill-companyuin-input9" className="text-muted">
                                {displayOrDash(order?.driverName)}
                              </Label>
                            </Col>
                          </Row>
                        </div>
                      )}






                      {(order?.statusDetails?.status === "picked" || order?.statusDetails?.status === "pick_up_failed") && (
                        <div>
                          <Row>
                            <Col lg="5" md="5" sm="4" xs="4">
                              <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                Name of shipper
                              </Label>
                            </Col>
                            <Col>
                              <Label> : </Label>
                            </Col>
                            <Col lg="5" md="6" sm="6" xs="6">
                              <Label for="basicpill-companyuin-input9" className="text-muted">
                                {displayOrDash(order?.statusDetails?.shipperName)}
                              </Label>
                            </Col>
                          </Row>
                        </div>
                      )}
                      {order?.statusDetails?.status === "delivered" && (
                        <div>
                          <Row>
                            <Col lg="5" md="5" sm="4" xs="4">
                              <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                Name of receiver
                              </Label>
                            </Col>
                            <Col>
                              <Label> : </Label>
                            </Col>
                            <Col lg="5" md="6" sm="6" xs="6">
                              <Label for="basicpill-companyuin-input9" className="text-muted">
                                {displayOrDash(order?.statusDetails?.receiverName)}
                              </Label>
                            </Col>
                          </Row>
                        </div>
                      )}

                      {(order?.statusDetails?.signature ||
                        order?.statusDetails?.deliveredDetails?.deliverSignature) && (
                        <div className="mb-3">
                          <Row>
                            <Col lg="5" md="5" sm="4" xs="4">
                              <Label className="text-muted fw-semibold">Signature</Label>
                            </Col>
                            <Col>
                              <Label>:</Label>
                            </Col>
                            <Col lg="5" md="6" sm="6" xs="6">
                              <div>
                                <img
                                  src={proofImageSrc(
                                    order.statusDetails.signature ||
                                      order.statusDetails.deliveredDetails?.deliverSignature
                                  )}
                                  alt="Signature"
                                  style={{
                                    maxWidth: "300px",
                                    border: "1px solid #ccc",
                                    borderRadius: "6px",
                                    padding: "4px",
                                  }}
                                />
                                {/* <div className="mt-2">
                                  {order.statusDetails.signature || "N/A"}
                                </div> */}
                              </div>
                            </Col>
                          </Row>
                        </div>
                      )}

                      {([
                        "picked",
                        "pick_up_failed",
                        "delivered",
                        "dropped",
                        "return",
                        "reattempt",
                      ].includes(
                        String(order?.statusDetails?.status || order?.orderStatus || "")
                      )) && (
                          <div>
                            {order?.statusDetails?.notes && (
                              <Row>
                                <Col lg="5" md="5" sm="4" xs="4">
                                  <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                    Notes
                                  </Label>
                                </Col>
                                <Col>
                                  <Label> : </Label>
                                </Col>
                                <Col lg="5" md="6" sm="6" xs="6">
                                  <Label for="basicpill-companyuin-input9" className="text-muted">
                                    {displayOrDash(order?.statusDetails?.notes)}
                                  </Label>
                                </Col>
                              </Row>
                            )}
                            <Row>
                              <Col lg="5" md="5" sm="4" xs="4">
                                <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                  Date
                                </Label>
                              </Col>
                              <Col>
                                <Label> : </Label>
                              </Col>
                              <Col lg="5" md="6" sm="6" xs="6">
                                <Label for="basicpill-companyuin-input9" className="text-muted">
                                  {displayOrDash(order?.statusDetails?.date)}
                                </Label>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="5" md="5" sm="4" xs="4">
                                <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                  Time
                                </Label>
                              </Col>
                              <Col>
                                <Label> : </Label>
                              </Col>
                              <Col lg="5" md="6" sm="6" xs="6">
                                <Label for="basicpill-companyuin-input9" className="text-muted">
                                  {displayOrDash(order?.statusDetails?.time)}
                                </Label>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="5" md="5" sm="4" xs="4">
                                <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                  Driver
                                </Label>
                              </Col>
                              <Col>
                                <Label> : </Label>
                              </Col>
                              <Col lg="5" md="6" sm="6" xs="6">
                                <Label for="basicpill-companyuin-input9" className="text-muted">
                                  {displayOrDash(order?.driverName)}
                                </Label>
                              </Col>
                            </Row>
                          </div>
                        )}
                      {(order?.statusDetails?.status === "pick_up_failed" ||
                        order?.statusDetails?.status === "dropped" ||
                        order?.statusDetails?.status === "delivered" ||
                        order?.statusDetails?.status === "return" ||
                        order?.statusDetails?.status === "reattempt") && (
                          <div>
                            <Row>
                              {/* <Col lg="5" md="5" sm="4" xs="4">
                              <Label for="basicpill-companyuin-input9" className="text-muted fw-semibold">
                                Notes
                              </Label>
                            </Col>
                            <Col>
                              <Label> : </Label>
                            </Col> */}
                              {order?.statusDetails?.imageData && (
                                <Col lg="6">
                                  <img className="mt-2" alt="Card cap" src={order?.statusDetails?.imageData} width="100%" />
                                </Col>
                              )}
                            </Row>
                          </div>
                        )}
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="d-flex flex-row flex-wrap justify-content-end">
            <button className="btn btn-primary" onClick={() => getPDF(orderId)}>
              Download PDF
            </button>
          </div>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default OrderStatusModal;
